export const LAYOUT_TYPES = {
  DROPDOWN: 'Dropdown',
  DIVIDER: 'Divider',
  SPACER: 'Spacer',
  INSERT_MENU: 'InsertMenu'
};

/** Configuration for the Formatting Tray capability (floating toolbar on selection) */